export default "__VITE_ASSET__BSjkhpLV__"